// Shared copy for login redirects (router state, query ?reason=, etc.)
export const LOGIN_REASON_MESSAGES = {
  session_expired:
    'Your session has expired. Please log in again to continue.',
  existing_account:
    'You already have a vendor account with this email. Log in with your existing credentials to register for this year\'s festival.',
  vendor_registration:
    'You already have a vendor account. Log in to continue your registration for this year.',
  vendor_dashboard:
    'Please log in with your vendor account to view your dashboard and continue registration.',
};

export const getLoginMessageForReason = (reason) =>
  reason ? LOGIN_REASON_MESSAGES[reason] || null : null;

const LOGIN_BANNER_STORAGE_KEY = 'gt:login_banner_message';

export const readLoginBanner = () => {
  if (typeof window === 'undefined') return '';
  return sessionStorage.getItem(LOGIN_BANNER_STORAGE_KEY) || '';
};

export const persistLoginBanner = (message) => {
  if (message && typeof window !== 'undefined') {
    sessionStorage.setItem(LOGIN_BANNER_STORAGE_KEY, message);
  }
};

export const clearLoginBanner = () => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(LOGIN_BANNER_STORAGE_KEY);
  }
};

export const resolveLoginBannerMessage = ({ stateMessage, reason }) => {
  const incoming = stateMessage || getLoginMessageForReason(reason) || '';
  if (incoming) return incoming;
  return readLoginBanner();
};
